import React, { useState } from 'react';
import { Container } from 'react-bootstrap';

import ProspectosContext from '../../context/ProspectosContext';
import AlertImageContext from '../../context/AlertImageContext';
import RenapoContext from '../../context/RenapoContext';
import LoadinContext from '../../context/LoadingContext';
import MapContext from "../../context/MapContext";
import CodeContext from "../../context/CodeContext";
import AlldataComp from "../../context/AlldataComp";
import PositionContext from "../../context/PositionContext";
import ViewContext from '../../context/ViewContext';
import LoadingTailwindContext from '../../context/LoadingTailwindContext';
import FormComp from './FormComp';
import AlertImageComp from '../Shared/AlertImageComp';

import '../../Styles/Index.css'
import ineFront from '../../Assets/Img/Register/CREDENCIALFRONT.png'
import ineBack from '../../Assets/Img/Register/CREDENCIALBACK.png'

const Form = () => {

    const [center,] = useState({
        lat: 19.432307,
        lng: -99.133550,
    });
    const oInitialFront = {
        // urlBase: 'https://webfullerette.fuller.com.mx/Content/img/ID_Image/CREDENCIALFRONT.jpg',
        // url: 'https://webfullerette.fuller.com.mx/Content/img/ID_Image/CREDENCIALFRONT.jpg',
        urlBase: ineFront,
        url: ineFront,
        file: [],
    };
    const oInitialBack = {
        urlBase: ineBack,
        url: ineBack,
        file: []
    };
    const initialpassport = {
        urlBase: 'https://webfullerette.fuller.com.mx/Content/img/ID_Image/PASAPORTE.jpg',
        url: 'https://webfullerette.fuller.com.mx/Content/img/ID_Image/PASAPORTE.jpg',
        file: [],
    }
    const [dataLoading, setDataLoading] = useState({ bool: false, label: "Validando información, espere por favor" })
    const [dataProspecto, setDataProspecto] = useState({ documentFront: oInitialFront, documentReverse: oInitialBack, passport: initialpassport, errorBoolINE: false, errorBoolPass: false });
    const [dataAlertImage, setDataAlertImage] = useState(AlertImageContext);
    const [dataRenapo, setDataRenapo] = useState({ Token: "", Correo: "", Celular: "", MaskCelular: "", Name: "", LastnameP: "", LastnameM: "", Genere: undefined, Year: undefined, Month: undefined, Day: 0, IDdocumento: 1, DocumentName: 'INE', Date: undefined, RFC: '', Referido: '', Colony: 'Colonia *', CoordinadoraData: '', CoordinadorName: '' })
    const [dataMap, setDataMap] = useState({ streetName: '', zipCode: '', colony: [], municipality: '', locality: '', state: '', streetNumber: '', currentLocation: false });
    const [dataCodeContext, setCodeContext] = useState(0);
    const [dataAlldataComp, setAlldataComp] = useState({ Contact: {}, CurrentLocation: {}, PersonalInfo: {}, CoordInfo: {} })
    const [position, setPosition] = useState(center);
    const [dataView, setdataView] = useState("DP"); //SMS, DP, LZ
    const [dataLoadingTailwind, setdataLoadingTailwind] = useState({ success: false, save: false, email: false, thinking: false, location: false, loading: false, label: "Validando información, espere por favor" });

    return (
        <AlertImageContext.Provider value={[dataAlertImage, setDataAlertImage]}>
            <Container className="container-principal container-Form">
                <ViewContext.Provider value={[dataView, setdataView]}>
                    <PositionContext.Provider value={[position, setPosition]}>
                        <AlldataComp.Provider value={[dataAlldataComp, setAlldataComp]}>
                            <CodeContext.Provider value={[dataCodeContext, setCodeContext]}>

                                <div className="container-principal" >
                                    <LoadingTailwindContext.Provider value={[dataLoadingTailwind, setdataLoadingTailwind]}>
                                        <LoadinContext.Provider value={[dataLoading, setDataLoading]}>
                                            <ProspectosContext.Provider value={[dataProspecto, setDataProspecto]}>
                                                <RenapoContext.Provider value={[dataRenapo, setDataRenapo]}>
                                                    <MapContext.Provider value={[dataMap, setDataMap]}>
                                                        <FormComp>
                                                            {dataAlertImage.bool && <AlertImageComp />}
                                                        </FormComp>
                                                    </MapContext.Provider>
                                                </RenapoContext.Provider>
                                            </ProspectosContext.Provider>
                                        </LoadinContext.Provider>
                                    </LoadingTailwindContext.Provider>
                                </div>
                            </CodeContext.Provider>
                        </AlldataComp.Provider>
                    </PositionContext.Provider>
                </ViewContext.Provider>

            </Container>
        </AlertImageContext.Provider>
    )
}

export default Form;